export default __webpack_public_path__ + "static/media/enginner2.97965f4a.png";